/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * AARON@INSPIRA IMPORTANT NOTE
 * The above is NOT correct, you need to dispatch an event with additional detail or the theme.js will break
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true,
 *   detail: {
 *     cart: cart_object,
 *     openMiniCart: true|false
 *   }
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/*////////////////////////////////
Mini-cart update PHC discount
////////////////////////////////*/
document.addEventListener("variant:changed", function (event) {
  //console.warn('variant changed')
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let phcPrices = document.querySelectorAll(
    ".product-item-meta__phc-discount span"
  );
  phcPrices.forEach((price) => {
    price.style.display = "none";
  });
  const elSelectedVariants = document.querySelectorAll(
    `[data-variant_id="${variant.id}"]`
  );
  if (elSelectedVariants.length) {
    elSelectedVariants.forEach((el) => {
      el.style.display = "inline";
    });
    document.getElementById("phc-price").value =
      elSelectedVariants[0].dataset.phc_price;
    document.getElementById("phc-member").value = getPhcCookie();
  }
});
/*////////////////////////////////
PHC Cookie Code
////////////////////////////////*/
const phcCookieName = "PHC";
const phcCookieValue = "temporary";
const phcCookieDuration = 60 * 60 * 24;

const phcAttemptsCookieName = "PhcAttempts";
const phcAttemptsCookieValue = "0";
const phcAttemptsCookieDuration = 60 * 60 * 24;

function setPhcCookieWithData(data) {
  document.cookie = `${phcCookieName}=${phcCookieValue}|${data};path=/;max-age=${phcCookieDuration}`;
}
function setPhcCookie() {
  document.cookie = `${phcCookieName}=${phcCookieValue};path=/;max-age=${phcCookieDuration}`;
}
function clearPhcCookie() {
  document.cookie = `${phcCookieName}=${phcCookieValue};path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
function getPhcCookieData() {
  const data = document.cookie
    .split(";")
    .find((item) => item.includes(`${phcCookieName}=${phcCookieValue}`));
  if (data) {
    return data.replace(` ${phcCookieName}=${phcCookieValue}|`, "");
  }
  return "";
}
function getPhcCookie() {
  if (
    document.cookie
      .split(";")
      .some((item) => item.includes(`${phcCookieName}=${phcCookieValue}`))
  ) {
    return true;
  }
  return false;
}
function setPhcAttemptsCookie(value) {
  document.cookie = `${phcAttemptsCookieName}=${value};path=/;max-age=${phcAttemptsCookieDuration}`;
}
function clearPhcAttemptsCookie() {
  document.cookie = `${phcAttemptsCookieName}=0;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
function getPhcAttemptsCookie() {
  if (document.cookie.includes(`${phcAttemptsCookieName}=`)) {
    return parseInt(
      document.cookie.split(`${phcAttemptsCookieName}=`)[1].split(";")[0]
    );
  }
  return 1;
}
/*////////////////////////////////
PHC / Referrer / Cart Updates
////////////////////////////////*/
async function setAllPhcMemberFields(productid, variantId = null) {
  /* PHC member fields */
  const frmElements = document.querySelectorAll(
    '[name="properties[_phc_member]"]'
  );
  frmElements.forEach((el) => {
    el.value = getPhcCookie();
  });
  /* Referrer Fields */
  const elReferrers = document.querySelectorAll(
    '[name="properties[_referrer]"]'
  );
  let activeReferrer = localStorage.getItem("referral_active");
  if (activeReferrer) {
    const referrerTimestamp = localStorage.getItem(
      `referral_${activeReferrer}`
    );
    console.log(referrerTimestamp);
    // check timestamp < 90 days old
    if (
      referrerTimestamp &&
      parseInt(referrerTimestamp) + 1000 * 60 * 60 * 24 * 90 >
        Date.now().valueOf()
    ) {
      elReferrers.forEach((elReferrer) => {
        elReferrer.value = activeReferrer;
      });
    } else {
      activeReferrer = false;
    }
  }
  if (!activeReferrer) {
    elReferrers.forEach((elReferrer) => {
      elReferrer.remove();
    });
  }

  fetch(
    window.Inspira.APP_URL +
      "/customers/notify/addtocart/" +
      window.Inspira.SHOP +
      "/" +
      productid
  ).then((response) => response.json());
}
function togglePhcFieldStatus(el, disable) {
  if (disable) {
    el.setAttribute("name", "_" + el.getAttribute("name"));
  } else {
    el.setAttribute("name", el.getAttribute("name").substring(1));
  }
}
function togglePhcPropertyFields(disable) {
  if (disable) {
    document.querySelectorAll('[name^="properties[_phc_').forEach((el) => {
      togglePhcFieldStatus(el, disable);
    });
  } else {
    document.querySelectorAll('[name^="_properties[_phc_').forEach((el) => {
      togglePhcFieldStatus(el, disable);
    });
  }
  Shopify.PaymentButton.init(); // Reinitialise Shopify Payment Button
}
function savePhcDiscountCode(phcDiscountCode) {
  sessionStorage.setItem("phc_discount", phcDiscountCode);
}
document.addEventListener("DOMContentLoaded", function () {
  if (getPhcCookie()) {
    document.body.classList.add("phc_member"); // Add phc_member class to body if we have cookie
    elAddToCart = document.getElementById("AddToCart");
    if (elAddToCart) elAddToCart.disabled = false; //1020322265 - Product restrictions - Enable add to cart button
  }
});
document.addEventListener("variant:added", (event) => {
  var variant = event.detail.variant; // Get the variant that was added
  console.debug("variant:added");

  // form GA data
  let variant_data = {
    item_id: variant.sku,
    item_name: variant.product_title,
    discount: variant.total_discount / variant.quantity / 100,
    item_brand: variant.vendor,
    item_category: variant.product_type,
    item_variant: variant.variant_title,
    price: variant.price / 100,
    quantity: variant.quantity,
  };

  let variant_value = variant.discounted_price / 100;

  if (variant.selling_plan_allocation) {
    variant_data.options = "subscription";
    variant_data.frequency = variant.selling_plan_allocation.selling_plan.name;
  } else {
    variant_data.options = "one-off";
  }

  if (variant.properties._phc_member === "true") {
    variant_data.discount =
      (variant.price - parseInt(variant.properties._phc_price)) / 100;
    variant_value = variant.properties._phc_price / 100;
  }

  // push data to GA
  dataLayer.push({
    event: "add_to_cart",
    eventSource: "hard_coded",
    ecommerce: {
      currency: "GBP",
      value: variant_value,
      items: [variant_data],
    },
  });

  console.debug(dataLayer);
});
document.addEventListener("cart:updated", (event) => {
  var cart = event.detail.cart; // Get the updated content of the cart
  console.debug("cart:updated");
});
document.addEventListener("cart:refresh", (event) => {
  console.debug("cart:refresh");
});
document.addEventListener("cart-notification:show", (event) => {
  console.debug("cart-notification:show");
});

/*////////////////////////////////
Misc Functions
////////////////////////////////*/
/* Polling function
fn: function returning true if condition met
timeout: how long in ms it will poll - Optional (default 2000)
interval: time in ms between checks - Optional (default 100)
*/
function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;
  var checkCondition = function (resolve, reject) {
    // If the condition is met, we're done!
    var result = fn();
    if (result) {
      resolve(result);
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(() => checkCondition(resolve, reject), interval);
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error("Timed out for " + fn + ": " + arguments));
    }
  };
  return new Promise(checkCondition);
}

/*  UPDATE MINICART LINE ITEMS & REFRESH
 *  Called from PHC Verification app
 *  And after PHC/Staff Login
 */
const updateMiniCartLineItems = async (login = true) => {
  // Get cart JSON (async)
  const cart = await fetch(`${window.themeVariables.routes.cartUrl}.js`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((cart) => cart.json())
    .then(async (cart) => {
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];
        console.debug(`Line ${index + 1}: ${JSON.stringify(item.properties)}`);

        if (item.properties["_phc_member"]) {
          item.properties["_phc_member"] = `${login}`;
          const response = await fetch(
            `${window.themeVariables.routes.cartChangeUrl}.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                line: index + 1,
                quantity: item.quantity,
                properties: item.properties,
              }),
            }
          );
        }
      }
      return cart;
    })
    .then(async (cart) => {
      // Tell theme to refresh mini cart
      cart.sections = {};
      // get the HTML for the mini-cart
      const response = await fetch(
        `${window.themeVariables.routes.cartUrl}?section_id=mini-cart`
      );
      cart.sections["mini-cart"] = await response.text();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: false,
          },
        })
      );
    });
};

async function saveBundleAttributes(existingCart, products, productWithTags) {
  const bundleItems = [];
  let productsWithTags =
    (typeof existingCart?.attributes?.productsWithTags === "string"
      ? JSON.parse(
          existingCart?.attributes?.productsWithTags?.replaceAll("=>", ":")
        )
      : existingCart?.attributes?.productsWithTags) || [];

  productsWithTags.push(productWithTags);

  productsWithTags.forEach((item) => {
    const stillInTheCart = existingCart.items.find(
      (product) => Number(product.variant_id) === Number(item.id)
    );

    if (!stillInTheCart) {
      productsWithTags = productsWithTags.filter(
        (product) => Number(product.id) !== Number(item.id)
      );
    } else {
      if (item.id === productWithTags.id) {
        const tagsList = new Set([...productWithTags.tags]);
        item.tags = Array.from(tagsList);
      }
    }
  });

  productsWithTags = Array.from(
    new Map(productsWithTags.map((item) => [Number(item.id), item])).values()
  );

  products.forEach((product) => {
    const { data, bundleId } = product;

    data.productVariant.productVariantComponents.nodes.forEach(
      ({ productVariant, quantity }) => {
        bundleItems.push({
          id: productVariant.id,
          price: Number(productVariant.price),
          tags: productVariant.product.tags,
          bundleVariantId: bundleId,
          quantity,
        });
      }
    );
  });

  const cart = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        bundleItems,
        productsWithTags,
      },
    }),
  });

  return await cart.json();
}

async function handleBundlesAndProductTags(productWithTags) {
  const existingCart = await (await fetch("/cart.js")).json();
  const itemIds = existingCart.items.map((item) => item.variant_id);

  try {
    const response = await fetch(
      `/apps/api/bundle/products?ids=${JSON.stringify(itemIds)}`
    );
    const products = await response.json();
    const cart = await saveBundleAttributes(
      existingCart,
      products,
      productWithTags
    );

    const miniCart = await fetch(
      `${window.themeVariables.routes.cartUrl}?section_id=mini-cart`
    );
    cart.sections = {};
    cart.sections["mini-cart"] = await miniCart.text();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart,
          openMiniCart: true,
        },
      })
    );
  } catch (e) {
    console.log(e);
  }
}

function triggerCartRearrange() {
  localStorage.setItem("rearrange-minicart", true);
}
function endCartRearrange() {
  localStorage.setItem("rearrange-minicart", false);
}
function shouldCartRearrange() {
  const flag = localStorage.getItem("rearrange-minicart");
  return localStorage.getItem("rearrange-minicart") === "true" ? true : false;
}

/*////////////////////////////////
Quick Buy Drawer/Popover
+ Update minicart on PHC/Staff login
////////////////////////////////*/
document.addEventListener("DOMContentLoaded", function () {
  if (window.Inspira?.updateMiniCart === true) {
    updateMiniCartLineItems();
  }

  if (shouldCartRearrange()) {
    updateMiniCartLineItems(false);
    // Turn off update flag
    endCartRearrange();
  }

  // Usage:  ensure element is visible
  poll(
    function () {
      return (
        document.querySelectorAll("quick-buy-popover,quick-buy-drawer").length >
        0
      );
    },
    1000,
    10
  )
    .then(function () {
      const targetNodes = document.querySelectorAll(
        "quick-buy-popover,quick-buy-drawer"
      );
      // Options for the observer (which mutations to observe)
      const config = {
        attributes: true,
        attributeFilter: ["open"],
        childList: true,
        subtree: true,
      };
      targetNodes.forEach((targetNode) => {
        const callback = function (mutationsList, observer) {
          for (const mutation of mutationsList) {
            if (mutation.type === "attributes") {
              document.getElementById("phc-member").value = getPhcCookie();
            }
          }
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
      });
    })
    .catch(function () {
      // Polling timed out, handle the error!
    });
});

// Handle product siblings in quickbuy
const toggleSibling = (variantData) => {
  const variantJson = JSON.parse(variantData.replaceAll("#", "'"));

  window.__currentSiblingVariantId = variantJson?.id;

  document.querySelector(".is-current").classList.remove("is-current");
  document
    .getElementById("SiblingQuickBuy_" + variantJson.id)
    .classList.add("is-current");
  document.getElementById("variant-id").value = variantJson.id;
  siblingPrices(variantJson);
};

const siblingPrices = (variantJson) => {
  let priceList = document.querySelector("[data-product-price-list]"),
    priceExperimentRrpDiscount = document.querySelector(
      ".price_experiment_rrp_discount"
    );

  const fadeIn = (element) => {
    var opacity = 0;
    let interval = setInterval(function () {
      if (opacity < 1) {
        opacity += 0.2;
        element.style.opacity = opacity;
      } else if (opacity == 0) {
      } else {
        clearInterval(interval);
      }
    }, 50);
  };

  return new Promise((resolve, reject) => {
    let opacity = 1;
    let interval = setInterval(function () {
      if (opacity > 0) {
        opacity -= 1;
        priceList.style.opacity = opacity;
        if (priceExperimentRrpDiscount)
          priceExperimentRrpDiscount.style.opacity = opacity;
      } else {
        clearInterval(interval);
        updateSiblingPrices(variantJson);
      }
    }, 50);
    resolve(true);
  }).then(() => {
    setTimeout(() => {
      priceList.style.visibility = "visible";
      fadeIn(priceList);
      if (priceExperimentRrpDiscount) fadeIn(priceExperimentRrpDiscount);
    }, 900);
  });
};

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

const updateSiblingPrices = (variant) => {
  const getHiddenFormValue = (id) => {
    return document.getElementById(id).value;
  };
  let discountValue = getHiddenFormValue("discount-value"),
    discountMultiply = getHiddenFormValue("discount-multiply"),
    phcDiscountPercent = getHiddenFormValue("phc-discount-percent"),
    phcDiscountCode = getHiddenFormValue("phc-discount-code"),
    withDiscountMultiply = getHiddenFormValue("with-discount-multiply"),
    subMultiply = getHiddenFormValue("sub-multiply"),
    phcSubDiscountPercent = getHiddenFormValue("phc-sub-discount-percent"),
    staffSavingEl = document.querySelector(".staff-saving-message span"),
    variantWeight = variant.weight / 1000,
    productPrices = document.querySelector("[data-product-price-list]"),
    currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;

  if (!productPrices) {
    return;
  }
  if (!variant) {
    productPrices.style.display = "none";
  } else {
    productPrices.innerHTML = "";
    if (variant["compare_at_price"] > variant["price"]) {
      productPrices.innerHTML += `<span class="price price--highlight ${
        this.priceClass
      }"><span class="visually-hidden">${
        window.themeVariables.strings.productSalePrice
      }</span>${formatMoney(variant["price"], currencyFormat)}</span>`;
      productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${
        window.themeVariables.strings.productRegularPrice
      }</span>${formatMoney(
        variant["compare_at_price"],
        currencyFormat
      )}</span>`;
    } else {
      let purchaseOption = null;
      let subRadios = document.getElementsByName("purchaseOption");
      subRadios.forEach((radio) => {
        if (radio.checked) {
          purchaseOption = radio.value;
        }
      });

      let discountPrice = variant.price * discountMultiply;
      /* check if phc-temp discount - don't stack discounts */
      let subPrice = discountPrice * subMultiply;
      if (phcDiscountCode.includes("phc-temp")) {
        subPrice = variant.price * subMultiply;
      }

      let finalPrice =
        purchaseOption == "subscription" ? subPrice : discountPrice;
      let pricePerKg = finalPrice / variantWeight;
      let compareHtml = "";

      if (variant.price > finalPrice) {
        compareHtml = `<span class="price--compare">${formatMoney(
          variant.price,
          currencyFormat
        )}</span>`;
      }
      if (window.Inspira.priceExperiment) {
        /* Price experiment */
        let discountValue = document.getElementById("discount-value").value;
        if (purchaseOption == "subscription") {
          discountValue = document.getElementById("sub-value").value;
        }
        productPrices.innerHTML += `
          <span class="price ${this.priceClass}">
            <div>
              <span class="price--compare">${
                discountValue > 0 ? "-" + discountValue + "%" : ""
              }</span>
              <span>${formatMoney(finalPrice, currencyFormat)}</span>
            </div>
          </span>
        `;
      } else {
        productPrices.innerHTML += `
          <span class="price ${this.priceClass}">
            <div>
              <span class="visually-hidden">${
                window.themeVariables.strings.productSalePrice
              }</span>
              ${compareHtml}
              <span>${formatMoney(finalPrice, currencyFormat)}</span>
            </div>
          </span>
        `;
      }
      //debugger
      if (variantWeight > 0) {
        productPrices.innerHTML += `<span class="price-per-kg">${formatMoney(
          pricePerKg,
          currencyFormat
        )}/kg</span>`;
      }

      if (staffSavingEl) {
        staffSavingEl.innerText = formatMoney(
          Math.floor(variant.price - discountPrice),
          currencyFormat
        );
      }

      let finalPhcDiscountPrice;

      if (purchaseOption == "subscription") {
        if (phcSubDiscountPercent > 0 && phcDiscountPercent > 0) {
          finalPhcDiscountPrice =
            variant.price * phcSubDiscountPercent * phcDiscountPercent;
        } else if (phcSubDiscountPercent > 0) {
          finalPhcDiscountPrice = variant.price * phcSubDiscountPercent;
        } else if (phcDiscountPercent > 0) {
          finalPhcDiscountPrice = variant.price * phcDiscountPercent;
        } else {
          finalPhcDiscountPrice = 0;
        }
      } else {
        if (phcDiscountPercent > 0) {
          finalPhcDiscountPrice = variant.price * phcDiscountPercent;
        } else {
          finalPhcDiscountPrice = 0;
        }
      }

      // let discountSaving = variant.price - discountPrice;
      let discountSaving = variant.price - finalPhcDiscountPrice;
      const phcVerified = document.getElementById("phc-verified"),
        PHCVerifyPrice = document.getElementById("PHCVerifyPrice"),
        dataVariantId = document.querySelector(
          `[data-variant_id="${variant.id}"]`
        ),
        withDiscountPrice = document.getElementById("PHCPrice"),
        phcDiscountMessage = document.querySelector(
          `.price_experiment_rrp_discount .discount_message`
        ),
        rrpMessage = document.querySelector(
          `.price_experiment_rrp_discount .rrp_message`
        ),
        phcSubDiscountCode = document.getElementById(`phc-sub-discount-code`);

      if (phcVerified) {
        phcVerified.innerHTML = `You save <span id="PHCVerifyPrice">${formatMoney(
          discountSaving,
          currencyFormat
        )}</span> with your Pet Health Club® discount`;
      }
      if (PHCVerifyPrice) PHCVerifyPrice.style.display = "inline-block";
      //if (dataVariantId) dataVariantId.innerText = formatMoney(finalPhcDiscountPrice, currencyFormat);
      //if (withDiscountPrice) withDiscountPrice.innerText = formatMoney(finalPhcDiscountPrice, currencyFormat);
      if (phcDiscountMessage)
        phcDiscountMessage.innerText = formatMoney(
          variant.price * withDiscountMultiply,
          currencyFormat
        );
      if (rrpMessage)
        rrpMessage.innerText = formatMoney(variant.price, currencyFormat);
    }
    if (variant["unit_price_measurement"]) {
      let referenceValue = "";
      if (variant["unit_price_measurement"]["reference_value"] !== 1) {
        referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`;
      }
      productPrices.innerHTML += `
      <div class="price text--subdued ${this.unitPriceClass}">
        <div class="unit-price-measurement">
          <span class="unit-price-measurement__price">${formatMoney(
            variant["unit_price"]
          )}</span>
          <span class="unit-price-measurement__separator">/</span>
          ${referenceValue}
          <span class="unit-price-measurement__reference-unit">${
            variant["unit_price_measurement"]["reference_unit"]
          }</span>
        </div>
      </div>
    `;
    }
    productPrices.style.display = "inline-flex";
  }
};

/*////////////////////////////////
Customer Account
////////////////////////////////*/
/*
function setRechargeKeys(rechargeKeys) {
  sessionStorage.setItem('rechargeKeys',JSON.stringify(rechargeKeys));
}
*/
